const state = {
    notifications: [],
};

const getters = {
    getNotifications: (state) => state.notifications,
};

const actions = {
    ADD_NOTIFICATION: ({ commit }, payload) => {
        commit('addNotification', payload);
    },
    REMOVE_NOTIFICATION: ({ state, commit }, payload) => {
        commit('removeNotification', payload);
    },
    CLEAR_NOTIFICATIONS: ({ commit }) => {
        commit('clearNotifications');
    },
};

const mutations = {
    addNotification: (state, notification) => {
        state.notifications.push({
            id: `f${(+new Date()).toString(16)}`,
            timeStamp: new Date().getTime(),
            ...notification,
        });
    },
    removeNotification: (state, id) => {
        state.notifications = state.notifications.filter(
            (notification) => id !== notification.id
        );
    },
    clearNotifications: (state) => {
        state.notifications = [];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
